import React, { createContext, useContext, useState } from 'react';

const MusicPlayerContext = createContext();

export const useMusicPlayer = () => useContext(MusicPlayerContext);

export const MusicPlayerProvider = ({ children }) => {
  const [musicUrl, setMusicUrl] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [trackTitle, setTrackTitle] = useState('');
  const [volume, setVolume] = useState(0.5);
  const [isLooping, setIsLooping] = useState(false); 

  const playMusic = (url, title = 'Unknown Track') => {
    setMusicUrl(url);
    setTrackTitle(title);
    setIsPlaying(true);
  };

  const stopMusic = () => {
    setMusicUrl(null);
    setIsPlaying(false);
  };

  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const toggleLoop = () => {
    setIsLooping(!isLooping);
  };

  return (
    <MusicPlayerContext.Provider value={{ 
      musicUrl, 
      isPlaying, 
      playMusic, 
      stopMusic, 
      togglePlayPause, 
      trackTitle, 
      volume, 
      setVolume,
      isLooping,
      toggleLoop
    }}>
      {children}
    </MusicPlayerContext.Provider>
  );
};
